import { CustomFieldVariety } from '../generated/types';
import { TranslateFn } from '../services/translationService';
import { assertUnreachable } from '../util/assertUnreachable';

export function varietyToTranslation(t: TranslateFn, variety: CustomFieldVariety) {
    switch (variety) {
        case CustomFieldVariety.Accreditation:
            return t('accr_ditations_39450');
        case CustomFieldVariety.Delegation:
            return t('d_l_gations_78318');
        case CustomFieldVariety.Event:
            return t('Event');
        case CustomFieldVariety.Position:
            return t('missions_63972');
        case CustomFieldVariety.UserInfo:
            return t('membres_11310');
        default:
            return assertUnreachable(variety);
    }
}
